import React from 'react'

import * as UbicacionService from 'services/ubicacionAlmacenamiento.service'

import { etiquetaCelda } from '../utils/etiqueta'

const BusquedaInversa = ({ onSeleccionar }) => {
  const [texto, setTexto] = React.useState('')
  const [resultados, setResultados] = React.useState([])
  const [cargando, setCargando] = React.useState(false)
  const [busqueda, setBusqueda] = React.useState(false)

  const timerRef = React.useRef(null)

  React.useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    const q = texto.trim()
    if (q.length < 2) {
      setResultados([])
      setBusqueda(false)
      return
    }
    setCargando(true)
    timerRef.current = setTimeout(async () => {
      try {
        const { data } = await UbicacionService.buscarProducto(q)
        setResultados(data || [])
        setBusqueda(true)
      } catch {
        setResultados([])
      } finally {
        setCargando(false)
      }
    }, 300)
    return () => clearTimeout(timerRef.current)
  }, [texto])

  return (
    <div className='ub-busqueda-inversa'>
      <div className='ub-bi-header'>
        <i className='fa fa-search' />
        <strong>¿Dónde está este producto?</strong>
      </div>
      <div className='ub-bi-input-row'>
        <input
          type='text'
          placeholder='Buscar por código o nombre del producto (mín. 2 caracteres)...'
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
        {texto && (
          <button
            type='button'
            className='btn btn-sm btn-light'
            onClick={() => setTexto('')}
            title='Limpiar'
          >
            <i className='fa fa-times' />
          </button>
        )}
      </div>

      {cargando && <div className='ub-bi-loading'>Buscando...</div>}

      {!cargando && busqueda && resultados.length === 0 && (
        <div className='ub-bi-empty'>No se encontraron productos asignados a ninguna celda.</div>
      )}

      {!cargando && resultados.length > 0 && (
        <div className='ub-bi-resultados'>
          {resultados.map((r) => {
            const etiqueta = etiquetaCelda(r.fila, r.columna, r.profundidad, r.estanteriaProfundidad)
            return (
              <div
                key={`${r._idUbicacion}-${r._idItem}`}
                className='ub-bi-resultado'
                onClick={() => onSeleccionar && onSeleccionar(r)}
              >
                <div className='ub-bi-res-info'>
                  <div className='ub-bi-res-titulo'>
                    {r.codigoProducto && <span>{r.codigoProducto} · </span>}
                    {r.nombreProducto}
                  </div>
                  <div className='ub-bi-res-meta'>
                    {r.almacenNombre && <>📦 {r.almacenNombre} · </>}
                    🗄️ <strong>{r.estanteriaCodigo || r.estanteriaNombre}</strong> ·{' '}
                    📍 <strong>{etiqueta}</strong> ({r.codigoUbicacion})
                  </div>
                </div>
                <div className='ub-bi-res-cantidad'>{r.cantidad}</div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default BusquedaInversa
